import React from 'react';
import ReactDOM from 'react-dom/client';
import "./index.css";

import App from './App';

import { createTheme } from '@mui/material/styles';
import rtlPlugin from 'stylis-plugin-rtl';
import { CacheProvider, ThemeProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import { prefixer } from 'stylis';



const theme = createTheme({
  direction: 'rtl',
});

// Create rtl cache
const cacheRtl = createCache({
  key: 'muirtl',
  stylisPlugins: [prefixer, rtlPlugin],
});




const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <CacheProvider value={cacheRtl}>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </CacheProvider>
  </React.StrictMode>
);
if (
  'serviceWorker' in navigator 
  // && process.env.NODE_ENV !== "development"
) {
  console.log(process.env.NODE_ENV)
  navigator.serviceWorker.register(
    '/service-worker.js?hash='+ parseInt(Date.now()/1000)
  )
}